module.exports = __webpack_public_path__ + "static/img/8641_phase_function_Paper_PointsHejduk_Prediction.7a80a3d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/8641_phase_function_Paper_PointsHejduk_Prediction.png
// module id = 3KEj
// module chunks = 0